import React from 'react';
import PlayCircleFilledOutlinedIcon from '@mui/icons-material/PlayCircleFilledOutlined';
import { SPACE_RESUME_BUTTON_ICON_SIZE } from './spaceWidgetConstants';

/** Figma: PlayCircleFilledOutlined — 20×20, filled circle with play cutout. */
const SpaceResumePlayIcon = () => (
  <PlayCircleFilledOutlinedIcon
    aria-hidden
    sx={{
      width: SPACE_RESUME_BUTTON_ICON_SIZE,
      height: SPACE_RESUME_BUTTON_ICON_SIZE,
      fontSize: SPACE_RESUME_BUTTON_ICON_SIZE,
      display: 'block',
      flexShrink: 0,
    }}
  />
);

export default SpaceResumePlayIcon;
